import { Grid, Stack, Typography } from "@mui/material";
import { GradientBox } from "src/components/GradientBox";
import { GradientTypography } from "src/components/GradientTypography";
import { useLgOrUp, useSmOrUp, useMdOrUp } from "src/themes";

import { FeaturesIntroBoxContent } from "./FeaturesIntroBoxContent";
import antiRugImage from "./images/AntiRug.png";
import limitOrdersImage from "./images/LimitOrders.png";
import multiChainImage from "./images/MultiChain.png";
import portfolioMonitoringImage from "./images/PortfolioMonitoring.png";
import quickSwapsImage from "./images/QuickSwaps.png";
import unlockableSessionsImage from "./images/UnlockableSessions.png";

export const FeaturesIntroSection = () => {
  const mdOrUp = useMdOrUp();
  const smOrUp = useSmOrUp();
  const lgOrUp = useLgOrUp();

  return (
    <Stack
      alignItems="center"
      my={{
        xs: 7.5,
        md: 30,
      }}
      gap={{
        xs: 3,
        md: 15,
      }}
    >
      <Stack alignItems="center" gap={1.25}>
        <Typography
          color="primary.main"
          variant="caption"
          textAlign="center"
          fontSize={{
            xs: 14,
            md: 16,
          }}
          fontWeight={600}
        >
          PADRE APP
        </Typography>

        <GradientTypography variant="h2" textAlign="center">
          next level
          {mdOrUp ? " " : <br />}
          trading
        </GradientTypography>
      </Stack>

      <Stack
        direction="row"
        gap={1}
        width="100%"
        maxWidth={1800}
        px={{
          xs: 0,
          md: 6,
          lg: 8,
          xl: 24,
        }}
      >
        <Grid container spacing={1}>
          <Grid item xs={12} md={6} lg={4}>
            <GradientBox
              height={smOrUp ? BIG_BOX_HEIGHT : MOBILE_BOX_HEIGHT}
              {...gradientBoxCommonProps}
            >
              <FeaturesIntroBoxContent
                title="multi-chain"
                text={
                  "All-on-one: Solana, Ethereum, Base, BNB. Seamless transition between chains - no need to switch between different apps."
                }
                imgSrc={multiChainImage}
              />
            </GradientBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <GradientBox
              height={
                smOrUp
                  ? !lgOrUp
                    ? BIG_BOX_HEIGHT
                    : SMALL_BOX_HEIGHT
                  : MOBILE_BOX_HEIGHT
              }
              {...gradientBoxCommonProps}
            >
              <FeaturesIntroBoxContent
                title="the fastest"
                text={
                  "Lightning-fast transactions with smart routing across all chains. Every transaction is simulated to minimize number of reverts."
                }
                imgSrc={quickSwapsImage}
              />
            </GradientBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <GradientBox
              height={smOrUp ? BIG_BOX_HEIGHT : MOBILE_BOX_HEIGHT}
              {...gradientBoxCommonProps}
            >
              <FeaturesIntroBoxContent
                title="automation"
                text={
                  "Best in market copy trading and limit orders with auto exit strategies. Set up buy dip, take profit or stop loss levels seamlessly."
                }
                imgSrc={limitOrdersImage}
              />
            </GradientBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <GradientBox
              height={
                smOrUp
                  ? !lgOrUp
                    ? BIG_BOX_HEIGHT
                    : SMALL_BOX_HEIGHT
                  : MOBILE_BOX_HEIGHT
              }
              {...gradientBoxCommonProps}
            >
              <FeaturesIntroBoxContent
                title="real-time portfolio"
                text={
                  "Multi-chain portfolio with historical PnL/balance charts, also for imported wallets. Know the expected payout before the swap."
                }
                imgSrc={portfolioMonitoringImage}
              />
            </GradientBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <GradientBox
              height={smOrUp ? BIG_BOX_HEIGHT : MOBILE_BOX_HEIGHT}
              mt={`${lgOrUp ? SMALL_BOX_HEIGHT - BIG_BOX_HEIGHT : 0}px`}
              {...gradientBoxCommonProps}
            >
              <FeaturesIntroBoxContent
                title="password encryption"
                text={
                  "Full control of your wallets with 2FA and Turnkey private key infrastructure. Private key encryption with user generated password."
                }
                imgSrc={unlockableSessionsImage}
              />
            </GradientBox>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <GradientBox
              height={smOrUp ? SMALL_BOX_HEIGHT : MOBILE_BOX_HEIGHT}
              {...gradientBoxCommonProps}
            >
              <FeaturesIntroBoxContent
                title="anti-rug protection"
                text={
                  "Powered by BloxRoute MEV protection service on Ethereum and Solana, Padre saves you from sandwich attacks."
                }
                imgSrc={antiRugImage}
              />
            </GradientBox>
          </Grid>
        </Grid>
      </Stack>
    </Stack>
  );
};

const BIG_BOX_HEIGHT = 400;
const SMALL_BOX_HEIGHT = 360;
const MOBILE_BOX_HEIGHT = 305;

const gradientBoxCommonProps = {
  alignItems: "flex-start",
  pt: 4,
  shadeStrength: 0.8,
  showGlowOnHover: true,
};
